export enum LeadFilterConditionOperatorEnums {
    NOT = "NOT",
    OR = "OR",
    AND = "AND",
    NOT_EQUALS = "NOT_EQUALS",
    NOT_IN = "NOT_IN",
    NOT_CONTAINS = "NOT_CONTAINS",
    EQUALS = "EQUALS",
    IN = "IN",
    CONTAINS = "CONTAINS",
    GREATER_THAN = "GREATER_THAN",
    LESS_THAN = "LESS_THAN",
    BETWEEN = "BETWEEN",
    IS_NULL = "NULL",
    IS_NOT_NULL = "IS_NOT_NULL",
    IS_EMPTY = "IS_EMPTY",
    IS_NOT_EMPTY = "IS_NOT_EMPTY",
}